module.exports = __webpack_public_path__ + "static/media/ordering-showcase.cc3038a3.mov";